import toString from './toString';
import toJSON from './toJSON';
export var TODO_STATUS;
(function (TODO_STATUS) {
    TODO_STATUS["COMPLETED"] = "COMPLETED";
    TODO_STATUS["NEED_ACTION"] = "NEEDS-ACTION";
})(TODO_STATUS || (TODO_STATUS = {}));
var ICalParser = {
    toJSON: toJSON,
    toString: toString,
};
export default ICalParser;
